import type { ReactNode } from 'react';

export const symbol_vignette: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Zm512.82-146.5Q725-414 725-480t-72.18-113.5Q580.63-641 481-641t-171.82 47.5Q237-546 237-480t72.18 113.5Q381.37-319 481-319t171.82-47.5Zm-301.32-42Q297-438 297-480t54.68-71.5q54.68-29.5 129.5-29.5t129.32 29.5Q665-522 665-480t-54.68 71.5Q555.64-379 480.82-379T351.5-408.5Z"
		/>
	</svg>
);
